import { normalizeAreasFromBackend } from "../../../shared/components/features/scope-of-work/helpers/normalizedAreasFromBackend";
import { ScopeOfWorkStep } from "../../../shared/components/features/scope-of-work/context/scope-of-work.types";
import type { ScopeOfWorkInitialPayload } from "../../../shared/components/features/scope-of-work/context/scope-of-work.types";
import type { AreaByScopeOfWork, ScopeOfWork } from "../../../scope-of-work/types/scope-of-work.interface";

function parseCostOverride(value: ScopeOfWork["costOverride"]) {
  if (value == null) return null;

  if (typeof value === "object") {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

function mapAreaFromApi(apiArea: AreaByScopeOfWork) {
  const squareFt = Number(apiArea.squareFt ?? 0);
  const quantity = Number(apiArea.quantity ?? 0);

  const tasks = (apiArea.tasks ?? []).map((task) => ({
    uid: task.uid,
    id: task.uid,
    name: task.name,
    active: typeof task.active === "boolean" ? task.active : quantity > 0,
    description: task.description,
    note: task.note ?? "",
  }));

  return {
    uid: apiArea.area?.uid ?? apiArea.areaUid,
    name: apiArea.area?.name ?? "Area",
    description: apiArea.area?.description,
    imageUrl: apiArea.area?.imageUrl,
    baseDurationInMinutes: apiArea.area?.baseDurationInMinutes ?? 0,

    squareFootages: [
      {
        quantity,
        squareFt,
      },
    ],

    tasks,
  };
}

export function mapScopeOfWorkToInitialPayload(scope: ScopeOfWork): ScopeOfWorkInitialPayload {
  const areasRaw = scope.areasByScopesOfWork ?? [];

  const mainAreas = areasRaw.filter((area) => !area.otherArea);
  const otherAreas = areasRaw.filter((area) => area.otherArea);

  const squareFootage = (scope as any).squareFootage ?? scope.typeOfPlace?.squareFootage ?? "";

  const squareFtNumber = Number(squareFootage) || Number(mainAreas[0]?.squareFt ?? 0);

  return {
    step: ScopeOfWorkStep.Categories,

    category: scope.category ?? null,

    places: scope.typeOfPlace?.typeOfPlace ?? scope.typeOfPlace ?? null,

    service: scope.typeOfService ?? null,

    serviceNameOverride: scope.serviceNameOverride ?? "",

    squareft: String(squareFootage || squareFtNumber || ""),

    averagePeople: scope.averagePeople ?? scope.typeOfPlace?.averagePeople ?? null,

    areas: normalizeAreasFromBackend(mainAreas.map(mapAreaFromApi), squareFtNumber),

    otherAreas: normalizeAreasFromBackend(otherAreas.map(mapAreaFromApi), squareFtNumber),

    objects: scope.additionalObjects ?? [],

    specialRequests: scope.specialRequests ?? [],

    costOverride: parseCostOverride(scope.costOverride),

    frequencyType: scope.frequencyType ?? null,

    travelBufferTimeInGeneral: scope.travelBufferTimeInGeneral ?? 0,
  };
}
